import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import Banner from '../../components/Banner/Banner';
import infinity from '../../assets/login/infinity.png';
import logo from '../../assets/logo.png';
import eyeOn from '../../assets/login/eyeOn.png';
import eyeOff from '../../assets/login/eyeOff.png';
import './ResetPassword.css';
import Modal from '../../components/Modal/Modal';
// services
import { authService } from '../../services/login';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorResponse, setErrorResponse] = useState(false);
  const [title, setTitle] = useState({ text: '', highlight: '' });
  const [message, setMessage] = useState('');
  const { email, code } = location.state || {};
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = (e, field) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
    setErrors(prev => ({
      ...prev,
      [field]: ''
    }));
  };

  const validateForm = () => {
    const newErrors = {
      newPassword: '',
      confirmPassword: ''
    };
    let hasErrors = false;

    if (!formData.newPassword) {
      newErrors.newPassword = 'Password is required';
      hasErrors = true;
    } else {
      // Validar longitud entre 8 y 16 caracteres
      if (formData.newPassword.length < 8 || formData.newPassword.length > 16) {
        newErrors.newPassword = 'Password must be between 8 and 16 characters';
        hasErrors = true;
      }

      // Validar que tenga mayúscula, minúscula y número
      if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).*$/.test(formData.newPassword)) {
        newErrors.newPassword = 'Password must contain at least one uppercase letter, one lowercase letter and one number';
        hasErrors = true;
      }
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password';
      hasErrors = true;
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
      hasErrors = true;
    }

    setErrors(newErrors);
    return !hasErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Aquí iría la lógica para actualizar la contraseña
      console.log('Password updated successfully');
      // Redireccionar al login
      try {
        const response = await authService.resetPassword({
          email: email, 
          code: code, 
          new_password: formData.newPassword
        });
        console.log('Password reset response:', response);
        if (response.data.status === 'success') {
          setTitle({ text: 'Password', highlight: 'Reset' });
          setMessage('Your password has been reset successfully.');
          setErrorResponse(false);
          setIsModalOpen(true);
        }
      } catch (error) {
        console.error('Failed to reset password:', error);
        setTitle({ text: 'Error', highlight: 'Reset' });
        setMessage(error.response?.data?.message || 'Failed to reset password');
        setErrorResponse(true);
        setIsModalOpen(true);
      }
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    navigate('/');
  };

  return (
    <div className="reset-password-container">
      <div className="reset-password-form-container">
        <img src={logo} alt="Barterflip Logo" className="logo" />
        <h1 className="title">
          CHANGE YOUR <span className="highlight">PASSWORD</span>
        </h1>
        <p className="subtitle">
          You are just one step away! Complete the{' '}
          <span className="highlight">information</span> and let's start learning!
        </p>

        <form onSubmit={handleSubmit} className="reset-password-form" noValidate>
          <Input
            type="password"
            placeholder="New password"
            value={formData.newPassword}
            onChange={(e) => handleChange(e, 'newPassword')}
            error={errors.newPassword}
            icon={eyeOff}
            iconAlt={eyeOn}
            required
          />
          <Input
            type="password"
            placeholder="Confirm password"
            value={formData.confirmPassword}
            onChange={(e) => handleChange(e, 'confirmPassword')}
            error={errors.confirmPassword}
            icon={eyeOff}
            iconAlt={eyeOn}
            required
          />
          <Button type="submit" fullWidth>Confirm</Button>
        </form>
      </div>
      <Banner image={infinity} />
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title={title}
        showConfirmButton={true}
        confirmText="Confirm"
        onConfirm={handleModalClose}
        message={message}
        error={errorResponse}
      />
    </div>
  );
};

export default ResetPassword;
